import { createClient, Client } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'

import { FormService } from '@/api/form/v1/form_pb'
import { BrokersService } from '@/api/brokers/v1/brokers_pb'

const formAddr = process.env.REACT_APP_FORM_ADDR ?? 'http://localhost:4242'

// Create a FormService client
export function connectFormClient(addr?: string): Client<typeof FormService> {
	const transport = createConnectTransport({
		baseUrl: addr ?? formAddr,
	})

	return createClient(FormService, transport)
}

export function connectBrokersClient(addr?: string): Client<typeof BrokersService> {
	const transport = createConnectTransport({
		baseUrl: addr ?? formAddr,
	})

	return createClient(BrokersService, transport)
}
